// Who a new Comms message notifies, shared by the open app (desktop
// notifications) and the `push` Edge Function (phones), so both follow the
// same rules.
import { mentionsMember, plainMentions } from './mentions.js';

/** A member's setting for a channel; no setting means 'all'. */
export type NotifyLevel = 'all' | 'mentions' | 'none';

export interface NotifyingMessage {
  author_id: string | null;
  author_kind: string;
  on_behalf_of: string | null;
  body: string;
  deleted_at: string | null;
  source: string | null;
}

/**
 * Whether a message notifies this member, by their setting for its channel.
 * Never for imported or deleted messages, your own posts, or Claude's posts
 * made for you.
 */
export function messageNotifies(message: NotifyingMessage, memberId: string, notify: NotifyLevel = 'all'): boolean {
  if (message.deleted_at || message.source) return false;
  if (message.author_kind === 'human' && message.author_id === memberId) return false;
  if (message.author_kind === 'claude' && message.on_behalf_of === memberId) return false;
  if (notify === 'none') return false;
  if (notify === 'mentions') return mentionsMember(message.body, memberId);
  return true;
}

/** The notification's title and text: channel and author, then the first line. */
export function notificationText(
  message: { body: string; parent_id: string | null },
  channelName: string,
  author: string,
): { title: string; body: string } {
  const first =
    plainMentions(message.body)
      .split('\n')
      .find((l) => l.trim()) ?? 'Sent an attachment';
  const line = first.trim();
  return {
    title: `${author} in #${channelName}${message.parent_id ? ' (thread)' : ''}`,
    body: line.length > 140 ? `${line.slice(0, 139)}…` : line,
  };
}
